var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "16BCB564-E9DA-49C6-9383-D9D45E3C8CB6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 47.9999 0 47.9999 48 0 48"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Weboldal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Synflex-Swagers",
    transform: "translate(-433.000000, -1011.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(433.000000, 1011.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9999,12.556 C47.9999,5.65 42.3499,0 35.4439,0 L12.5559,0 C5.6499,0 -0.0001,5.65 -0.0001,12.556 L-0.0001,35.444 C-0.0001,42.35 5.6499,48 12.5559,48 L20.2499,48 L20.2499,31.726 L14.1559,31.726 L14.1559,24.788 L20.2499,24.788 L20.2499,19.501 C20.2499,13.486 23.8329,10.163 29.3149,10.163 C31.9409,10.163 34.6879,10.632 34.6879,10.632 L34.6879,16.538 L31.6609,16.538 C28.6799,16.538 27.7499,18.388 27.7499,20.286 L27.7499,24.788 L34.4059,24.788 L33.3419,31.726 L27.7499,31.726 L27.7499,48 L35.4439,48 C42.3499,48 47.9999,42.35 47.9999,35.444 L47.9999,12.556 Z",
    id: "Fill-1",
    fill: "#363636",
    mask: "url(#mask-2)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f565ef2afd5f02ed0be6e90a1bf9bb76.svg";
export { ForwardRef as ReactComponent };